<nav class="bg-c-yellow" id="nav-user-name">
  <span style="color: black;" i18n="@@UserName">Benutzer:&ensp;</span><strong>{{ user?.firstName }} {{ user?.lastName }}</strong>
</nav>

<main id="user-overview">
  <div class="card">
    <nav>
      <div id="nav-tab" role="tablist">
        <ul ngbNav #nav="ngbNav" [activeId]="activeTab" class="nav-tabs nav-pills">
          <li [ngbNavItem]="'profile'" domId="tab_profile">
            <a ngbNavLink routerLink="profile" i18n="@@ProfileLink"><app-svg source="icons/feather/settings" height="18"></app-svg>Profil</a>
          </li>
        </ul>
      </div>
    </nav>

    <div class="card">
      <div class="card-body">
        <div class="tab-content mt-2" id="nav-tabContent">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>

    <div class="card-footer" [ngStyle]="{'display': componentSettings.footerVisible == true ? 'block' : 'none' }">
      <div class="d-flex">
        <div class="flex-fill d-none d-md-inline">
          <div class="d-flex">
            <div class="flex p-2" i18n="@@ElementsPerPage">Elemente pro Seite</div>
            <div class="flex">
              <select id="pageSize" name="pageSize" [(ngModel)]="tableFunctions.pageSize" class="form-control form-select custom-select" aria-label="" (change)="tableFunctions.onPageSizeChange(className)">
                <option [ngValue]="10">10</option>
                <option [ngValue]="25">25</option>
                <option [ngValue]="50">50</option>
                <option [ngValue]="100">100</option>
                <option [ngValue]="250">250</option>
              </select>
            </div>
          </div>
        </div>
        <div class="d-flex d-md-inline-flex flex-fill text-center justify-content-center">
          <ngb-pagination #pagination
                          [collectionSize]="(tableFunctions.total$ | async)!"
                          [(page)]="tableFunctions.page"
                          [pageSize]="tableFunctions.pageSize"
                          [maxSize]="tableFunctions.page == 4 ? 4 : 3"
                          [boundaryLinks]="true"
                          [rotate]="true">
          </ngb-pagination>
        </div>
        <div class="flex-fill justify-content-end d-none d-md-inline">
          <div class="d-flex float-end">
            <div class="flex p-2" i18n="@@GoToPage">Springe zu Seite</div>
            <div class="flex">
              <select id="page" name="page" [(ngModel)]="tableFunctions.page" class="form-control form-select" aria-label="">
                <option *ngFor="let page of [].constructor(pagination.pageCount); let i = index" [ngValue]="i + 1">{{ i + 1 }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
